<template>
  <LcHeader
    :fly-out-toggle-aria-label="$t('highfrequencygame.header.button.flyout')"
    fly-out-toggle-class="paragraph-bold"
    :with-fly-out="showFlyOut"
    @left-button-click="handleClick"
  >
    <template #fly-out-content>
      <HighFrequencyGamePriceBreakdown />
    </template>

    <template #fly-out-toggle>{{ chargeTotal }}</template>

    <template #headline>
      <LcLotteryLogo v-bind="{ licensedTerritory }" :lottery-id="gameId" />
    </template>

    <slot />
  </LcHeader>
</template>

<script lang="ts" setup>
import type { LcHeaderProps } from '@lottocom/frontend-components'

type Props = Pick<LcHeaderProps, 'withFlyOut'> & {
  onClick?: () => void
}

const { onClick, withFlyOut } = defineProps<Props>()

const licensedTerritory = useLicensedTerritory({ raw: true })
const { currentPrice, gameId } = useHighFrequencyGame()
const { back, chargeTotal, showFlyOut } = usePriceBreakdownHeader(currentPrice, withFlyOut)

const handleClick = () => {
  if (onClick) return onClick()
  back()
}
</script>
